module.exports = __webpack_public_path__ + "img/thumb_22.c6b439de.jpg";